export const apiUrl = 'https://statement-api.moneyforward.com/'
export const loginApiUrl = 'https://id.moneyforward.com/'
export const clientId = '10d277e71624fcd551fde49829df0c87481b0bc60a1a7b227458b9287ec3855f'
export const loginServiceUrl = 'https://account.moneyforward.com/mfid/login'
export const accountServiceUrl = 'https://account.moneyforward.com/'

export const redirectUri = 'https://statement.moneyforward.com'

// other information
export const downloadSoftwareLink = 'https://prod-mfsc-download.s3-ap-northeast-1.amazonaws.com/extender/MFExtenderSetupForAba.exe'
export const downloadSoftwareLinkIe = 'https://prod-mfsc-download.s3-ap-northeast-1.amazonaws.com/extender/MFCloudExtender.application?product=aba'
export const productAbbreviation  = 'statement'

// Tracking id
export const trackingId = 'UA-148350148-1'
